<template>
    <main>
        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase">
                        <b><i class="fa fa-clock-o"></i> TESTES EM ANDAMENTO</b>
                    </h2>
                </div>
            </div>
            <!--<div class="col-sm-6">
                <button class="btn-large-40 btn-success uppercase pull-right" v-if="!hasDisabled" @click="openCreate()">
                    Candidatar
                </button>
            </div>-->

            <div class="col-sm-12 div-candidato-teste">
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <th>
                                    Processo Expira Em
                                    <i class="fa fa-question-circle" v-b-tooltip.right title="Provas e entrevistas devem ser concluídos
                                                          até 30 dias após a data de início do processo seletivo. Após esse prazo, o processo é considerado concluído.
                                                          Testes não finalizados terão resultado de reprovação,
                                                          e entrevistas não realizadas/finalizadas apresentarão o status 'não contratado'."></i>
                                </th>
                                <th>
                                    Nota
                                    <i class="fa fa-exclamation-circle" v-b-tooltip.right title="A nota final é calculada na forma de média ponderada.
                                            Ou seja, matérias com mais questões farão com que cada acerto tenha um valor menos significativo na média final"></i>
                                </th>
                                <th>Situação Teste</th>
                                <th>Teste Feito em</th>
                                <th>Situação Entrevista</th>
                                <th class="text-center" width="175" v-if="!hasDisabled">
                                    <i class="fa fa-cog"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.candidatoId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td v-if="item.podeConfigurarAcesso && item.chaveAcesso">Link enviado em {{ item.dtUltimaInteracao }} - Aguardando confirmação do colaborador</td>
                                <td v-else>{{ item.dtLiberacao }}</td>
                                <td>
                                    {{ item.teste && item.teste.dtTermino ? item.teste.nota + '%' : '--' }}
                                    <button type="button" v-if="item.teste && item.teste.dtTermino" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes Acertos" @click="openDetailsAcertos(item)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </td>
                                <td>{{ item.teste ? item.teste.situacaoTeste.nome : 'Teste não liberado' }}</td>
                                <td>{{ item.teste ? item.teste.dtTermino : '--' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.situacaoEntrevista.nome : '--' }}</td>

                                <td class="text-center" v-if="!hasDisabled">
                                    <div v-if="item.escolaId == escolaLogadaId">
                                        <button type="button" class="btn btn-sm btn-primary" v-if="item.podeLiberarTeste" v-canaccess="'/candidato/realizarteste'" v-b-tooltip title="Realizar teste" @click="openLiberarTeste(item)">
                                            <i class="fa fa-check"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-if="item.podeRealizarTeste" v-canaccess="'/candidato/realizarteste'" v-b-tooltip title="Realizar teste" @click="openRealizarTeste(item)">
                                            <i class="fa fa-check"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-info" v-if="item.podeContinuarTeste" v-canaccess="'/candidato/realizarteste'" v-b-tooltip title="Continuar teste" @click="openRealizarTeste(item)">
                                            <i class="fa fa-forward"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning" v-if="item.podeContinuarTeste" v-canaccess="'/candidato/realizarteste'" v-b-tooltip title="Reiniciar teste" @click="openReiniciarTeste(item)">
                                            <i class="fa fa-refresh"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-primary" v-if="item.podeAgendarEntrevista" v-canaccess="'/candidato/realizarentrevista'" v-b-tooltip title="Realizar entrevista" @click="openLiberarEntrevista(item)">
                                            <i class="fa fa-address-card-o"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-if="item.podeRealizarEntrevista" v-canaccess="'/candidato/realizarentrevista'" v-b-tooltip title="Realizar entrevista" @click="openRealizarEntrevista(item)">
                                            <i class="fa fa-address-card-o"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning" v-if="item.podeRealizarContratacao" v-canaccess="'/candidato/realizarentrevista'" v-b-tooltip title="Concluir processo" @click="openRealizarEntrevista(item)">
                                            <i class="fa fa-address-card-o"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning" v-if="item.podeConfigurarAcesso" v-canaccess="'/candidato/realizarentrevista'" v-b-tooltip title="Configurar Acesso" @click="openConfigurarAcesso(item)">
                                            <i class="fa fa-key"></i>
                                        </button>

                                        <a :href="'/contratar-confirmacao/' + item.chaveAcesso + '/?viacnajobs=true'" target="_blank" v-if="item.chaveAcesso && item.podeConfigurarSenha" class="btn btn-sm btn-secondary" v-b-tooltip title="Configurar Senha" @click="openedContratarConfirmacao()">
                                            <i class="fa fa-lock"></i>
                                        </a>
                                    </div>
                                    <div v-canaccess="'/candidato/podeDeletarTestes'">
                                        <button type="button" class="btn btn-sm btn-danger" v-if="escolaLogadaId == 276" v-b-tooltip title="Remover" @click="openRemove(item)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-12" v-if="result.outrasescolasgrupo.length > 0">
                <div class="row">
                    <div class="col-sm-12">
                        <hr />
                    </div>
                    <div class="col-md-6">
                        <div class="titles">
                            <h2 class="uppercase">
                                <b><i class="fa fa-plus-square-o"></i> TESTES EM ANDAMENTO NAS ESCOLAS DO GRUPO</b>
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <th>Teste Feito em</th>
                                <th>Nota</th>
                                <th>Situação Teste</th>
                                <th>Situação Entrevista</th>
                                <th>Entrevista feita em</th>
                                <th>Conceitos Entrevista</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.outrasescolasgrupo" v-bind:key="item.candidatoId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td>{{ item.teste && item.teste.dtTermino ? item.teste.dtTermino : '--' }}</td>
                                <td>
                                    {{ item.teste && item.teste.dtTermino ? item.teste.nota + '%' : '--' }}
                                    <button type="button" v-if="item.teste && item.teste.dtTermino" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes Acertos" @click="openDetailsAcertos(item)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </td>
                                <td>{{ item.teste ? item.teste.situacaoTeste.nome : 'Teste não liberado' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.situacaoEntrevista.nome : '--' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.dtEntrevista: '--' }}</td>
                                <td class="text-center">
                                    <button v-if="item.entrevista != null" type="button" class="btn btn-sm btn-success" v-b-tooltip title="Visualizar Entrevista" @click="openDetailsEntrevista(item)">
                                        <i class="fa fa-address-card-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-12" v-if="result.realizados.length > 0">
                <div class="row">
                    <div class="col-md-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="titles">
                            <h2 class="uppercase">
                                <b><i class="fa fa-check"></i> TESTES REALIZADOS NA ESCOLA</b>
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <th>Teste Feito em</th>
                                <th>Nota</th>
                                <th>Situação Teste</th>
                                <th>Situação Entrevista</th>
                                <th>Entrevista feita em</th>
                                <th>Conceitos Entrevista</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.realizados" v-bind:key="item.candidatoId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td>{{ item.teste ? item.teste.dtTermino ? item.teste.dtTermino : item.teste.dtInicio : item.dtLiberacao }}</td>
                                <td>
                                    {{ item.teste ? item.teste.nota + '%' : '--' }}
                                    <button type="button" v-if="item.teste" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes Acertos" @click="openDetailsAcertos(item)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </td>
                                <td>{{ item.teste ? item.teste.situacaoTeste.nome : '--'}}</td>
                                <td>{{ item.entrevista ? item.entrevista.situacaoEntrevista.nome : 'Não Contratado' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.dtEntrevista: '--' }}</td>
                                <td class="text-center">
                                    <button v-if="item.entrevista != null" type="button" class="btn btn-sm btn-success" v-b-tooltip title="Visualizar Entrevista" @click="openDetailsEntrevista(item)">
                                        <i class="fa fa-address-card-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-12" v-if="result.outrasescolas.length > 0">
                <div class="row">
                    <div class="col-md-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="titles">
                            <h2 class="uppercase">
                                <b><i class="fa fa-check-square-o"></i> TESTES REALIZADOS EM OUTRAS ESCOLAS</b>
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <th>Teste Feito em</th>
                                <th>Nota</th>
                                <th>Situação Teste</th>
                                <th>Situação Entrevista</th>
                                <th>Entrevista feita em</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.outrasescolas" v-bind:key="item.candidatoId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td>{{ item.teste ? item.teste.dtTermino ? item.teste.dtTermino : item.teste.dtInicio : item.dtLiberacao }}</td>
                                <td>
                                    {{ item.teste ? item.teste.nota + '%' : '--' }}
                                    <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes Acertos" @click="openDetailsAcertos(item)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </td>
                                <td>{{ item.teste ? item.teste.situacaoTeste.nome : '--' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.situacaoEntrevista.nome : 'Não Contratado' }}</td>
                                <td>{{ item.entrevista ? item.entrevista.dtEntrevista: '--' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-12" v-if="result.testeRefeitos.length > 0">
                <div class="row">
                    <div class="col-md-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="titles">
                            <h2 class="uppercase">
                                <b><i class="fa fa-check-square-o"></i> TESTES REFEITOS</b>
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <th>Teste Refeito em</th>
                                <th>Nova Nota Atingida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.testeRefeitos" v-bind:key="item.candidatoId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td>{{ item.teste ? item.teste.dtTermino ? item.teste.dtTermino : item.teste.dtInicio : item.dtLiberacao }}</td>
                                <td>
                                    {{ item.teste ? item.teste.nota + '%' : '--' }}
                                    <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Detalhes Acertos" @click="openDetailsAcertos(item)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogCreate" :hide-footer="true" title="Confirmação de Candidatura">
            <form-create v-if="dialogCreate" :escola-id="escolaId" :colaborador-id="colaboradorId" @on-saved="onSaved" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLiberarEntrevista" :hide-footer="true" title="Liberar Entrevista">
            <form-liberar-entrevista v-if="dialogLiberarEntrevista" :id="candidatoId" @on-saved="openRealizarEntrevista" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogDetailsEntrevista" :hide-footer="true" title="Detalhes da Entrevista">
            <details-entrevista v-if="dialogDetailsEntrevista" :candidatoId="candidatoId" :entrevistaId="entrevistaId" @on-back="hideAll" />
        </b-modal>
        <!-- task-1798 -->
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogDetailsAcertos" :hide-footer="true" title="Detalhes Acertos">
            <details-acertos v-if="dialogDetailsAcertos" @on-back="hideAll" :testeId="testeId" />
        </b-modal>
        <!--fim-->

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogLiberarTeste" :hide-footer="true" title="Liberar Teste">
            <form-liberar-teste v-if="dialogLiberarTeste" :escolaid="escolaId" :id="candidatoId" :testeId="testeId" @on-saved="openRealizarTeste" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogReiniciarTeste" :hide-footer="true" title="Reiniciar Teste">
            <form-reiniciar-teste v-if="dialogReiniciarTeste" :id="candidatoId" @on-saved="openRealizarTeste" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogRealizarEntrevista" :hide-footer="true" title="Realizar Entrevista">
            <form-realizar-entrevista v-if="dialogRealizarEntrevista" :candidatoId="candidatoId" :entrevistaId="entrevistaId" @on-saved="onSaved" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogConfigurarAcesso" :hide-footer="true" title="Configurar Novo Colaborador">
            <form-configurar-acesso v-if="dialogConfigurarAcesso" :candidatoId="candidatoId" @on-saved="onSaved" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogConfigurarSenha" :hide-footer="true" title="Configurar Nova Senha">
            <form-senha v-if="dialogConfigurarSenha" :colaboradorId="candidatoId" @on-saved="onSaved" @on-back="hideAll" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import auth from '@/common/auth'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formLiberarEntrevista from './form-liberar-entrevista'
    import detailsEntrevista from './details-entrevista'
    import detailsAcertos from './details-acertos'
    import formLiberarTeste from './form-liberar-teste'
    import formRealizarEntrevista from './form-realizar-entrevista'
    import formConfigurarAcesso from './form-configurar-acesso'
    import formReiniciarTeste from './form-reiniciar-teste'
    import formSenha from '../colaborador/form-senha'

    export default {
        name: 'candidato-content',
        mixins: [base],
        components: {
            formCreate,
            formLiberarEntrevista,
            detailsEntrevista,
            detailsAcertos,
            formLiberarTeste,
            formConfigurarAcesso,
            formSenha,
            formRealizarEntrevista,
            formReiniciarTeste
        },
        props: { colaboradorId: Number, escolaId: Number, considerarEscolaFranquia: Boolean, hasDisabled: Boolean },
        data() {
            return {

                resources: {
                    filter: 'candidato',
                    remove: 'candidato'
                },

                dialogCreate: false,
                dialogLiberarEntrevista: false,
                dialogDetailsEntrevista: false,
                dialogDetailsAcertos: false,
                dialogLiberarTeste: false,
                dialogReiniciarTeste: false,
                dialogRemove: false,
                dialogRealizarEntrevista: false,
                dialogConfigurarAcesso: false,
                dialogConfigurarSenha: false,

                model: {},
                cpf: null,

                result: {
                    items: [],
                    realizados: [],
                    outrasescolasgrupo: [],
                    outrasescolas: [],
                    testeRefeitos:[],
                },

            }
        },
        methods: {
            openRealizarTeste: function (model) {
                this.candidatoId = model.candidatoId;
                this.cpf = model.colaborador.cpf;
                this.testeId = model.testeId;
                this.dialogLiberarTeste = true;
                //var token = auth.getAccessToken();
                //var candidatoId = model.candidatoId;
                //var testeId = model.testeId;

                //var _url = '/teste-realizar/' + candidatoId + '/' + testeId;

                //if (model.colaborador && model.colaborador.cpf)
                //    _url += '/' + model.colaborador.cpf.replace(/\D+/g, '');
                //else if (this.cpf)
                //    _url += '/' + this.cpf.replace(/\D+/g, '');

                //_url += '/?accesstoken=' + token;

                //var routeData = this.$router.resolve({ path: _url });

                //var params = [
                //    'height=' + screen.availHeight,
                //    'width=' + screen.availWidth,
                //    'fullscreen=yes'
                //].join(',');

                //var popup = window.open(routeData.href, "newWin", params);
                //if (popup.outerWidth < screen.availWidth || popup.outerHeight < screen.availHeight) {
                //    popup.resizeTo(screen.availWidth, screen.availHeight);
                //    popup.moveTo(0, 0);
                //}

                //if (window.location.origin.indexOf("localhost") == -1)
                //    auth.logout();

            },
            openedContratarConfirmacao: function () {
                this.$emit('on-back')
            },
            openConfigurarAcesso: function (model) {
                this.candidatoId = model.candidatoId;
                this.testeId = model.testeId;
                this.dialogConfigurarAcesso = true;
            },
            openRealizarEntrevista: function (model) {
                this.candidatoId = model.candidatoId;
                this.entrevistaId = model.entrevistaId;
                this.testeId = model.testeId;
                this.dialogRealizarEntrevista = true;
            },
            openDetailsEntrevista: function (model) {
                this.candidatoId = model.candidatoId;
                this.entrevistaId = model.entrevistaId;
                this.testeId = model.testeId;
                this.dialogDetailsEntrevista = true;
            },
            openDetailsAcertos: function (model) {
                this.testeId = model.testeId;
                this.dialogDetailsAcertos = true;
            },
            openLiberarEntrevista: function (model) {
                this.candidatoId = model.candidatoId;
                this.testeId = model.testeId;
                this.dialogLiberarEntrevista = true;
            },
            openLiberarTeste: function (model) {
                this.candidatoId = model.candidatoId;
                this.cpf = model.colaborador.cpf;
                this.testeId = model.testeId;
                this.dialogLiberarTeste = true;
            },
            openReiniciarTeste: function (model) {
                this.candidatoId = model.candidatoId;
                this.cpf = model.colaborador.cpf;
                this.testeId = model.testeId;
                this.dialogReiniciarTeste = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function (data) {
                this.hideAll();
                this.executeLoad();

                if (data && data.doOpenConfigurarAcesso) {
                    new Api(this.resources.filter).get({ id: this.candidatoId }).then(data => {
                        if (data.data.situacaoCandidatoId == 1)
                            this.openConfigurarAcesso({ candidatoId: this.candidatoId });
                    });
                }
            },
            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = { candidatoId: model.candidatoId };
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogLiberarEntrevista = false;
                this.dialogDetailsEntrevista = false;
                this.dialogDetailsAcertos = false;
                this.dialogLiberarTeste = false;
                this.dialogRemove = false;
                this.dialogRealizarEntrevista = false;
                this.dialogConfigurarAcesso = false;
            },
            executeLoad: function () {
                this.showLoading();

                let _filter = {
                    colaboradorId: this.colaboradorId,
                    escolaId: this.escolaId,
                    candidaturaEmAndamento: true,
                    isPagination: false//Task-1735
                }

                new Api(this.resources.filter).get(_filter).then(data => {
                    this.result.items = data.dataList;
                    this.escolaLogadaId = +auth.currentUser().tenant;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            executeLoadRealizados: function () {
                this.showLoading();

                let _filter = {
                    colaboradorId: this.colaboradorId,
                    escolaId: this.escolaId,
                    candidaturaEncerradas: false,
                    testesRealizados: true,
                    isPagination: false//Task-1735
                }
                //console.log("objeto de filtro: ",_filter);
                new Api(this.resources.filter).get(_filter).then(data => {
                    this.result.realizados = data.dataList;
                    //console.log("lista realizados: ", this.result.realizados);
                    //console.log("end point: ", this.resources.filter);
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            executeLoadOutrasEscolasGrupo: function () {
                this.showLoading();

                let _filter = {
                    colaboradorId: this.colaboradorId,
                    candidaturaEmAndamento: true,
                    candidaturaEmAndamentoEscolaDoGrupoId: this.escolaId,
                    isPagination: false//Task-1735
                }

                new Api(this.resources.filter).get(_filter).then(data => {
                    this.result.outrasescolasgrupo = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            executeLoadOutrasEscolas: function () {
                this.showLoading();

                let _filter = {
                    colaboradorId: this.colaboradorId,
                    diferenteEscolaId: this.escolaId,
                    candidaturaEncerradas: true,
                    isPagination: false//Task-1735
                }

                new Api(this.resources.filter).get(_filter).then(data => {
                    this.result.outrasescolas = data.dataList;
                    //console.log(this.resources.filter+"endpoint api");
                    //console.log("itens das escolas",this.result.outrasescolas);
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            executeLoadTesteRefeitos: function () {
                this.showLoading();

                let _filter = {
                    colaboradorId: this.colaboradorId,
                    testesRealizados: true,
                    somenteTestesRepetidos: true,
                    EhTesteRepetida: true,
                    isPagination: false//Task-1735
                }

                new Api(this.resources.filter).get(_filter).then(data => {
                    this.result.testeRefeitos = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },



        mounted() {
            this.executeLoad();
            this.executeLoadOutrasEscolas();
            this.executeLoadOutrasEscolasGrupo();
            this.executeLoadRealizados();
            this.executeLoadTesteRefeitos();
        }

    };
</script>